import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const ReportsMappingsView = angular
  .module('acme.view.application.reports.mappings', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.view.application.reports.mappings.controllers',
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const reportsMappings = {
      name: 'application.reports.mappings',
      url: '/aliases',
      views: {
        'subview-main': {
          controller: 'ReportsMappingsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/reports/mappings/mappings.tpl.html',
        },
      },
      data: {
        pageTitle: 'Field Aliases',
        permissions: ['REPORT_FIELDS_VIEW'],
      },
      resolve: {
        DataSources: [
          'ApiService',
          function (ApiService) {
            return ApiService.analytics.report.config.datasources();
          },
        ],
      },
    };

    $stateProvider.state(reportsMappings);
  }).name;
